import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react";
import React, { useCallback, useEffect, useState } from "react";
import { Dots } from "react-activity";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import { addPrivacyPolicy, addisLoading } from "../../../utils/redux/mainSlice";
import {
  addSettingsContent,
  deleteContent,
  getSettingsContentByTitle,
} from "../../../utils/apis/func";
import { RootState } from "../../../utils/redux/store";
import { toast } from "react-toastify";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import TextEditor from "../../TextEditor";

const CustomerTerms = () => {
  const [newPrivacy, setNewPrivacy] = useState<any>();
  const dispatch = useAppDispatch();
  const fetchChats = async () => {
    dispatch(addisLoading(true));
    const res: any = await getSettingsContentByTitle("Customer Terms");
    setNewPrivacy(res?.data?.data);
    console.log("res get privacyPolicay fromdb ", res);
    if (res?.status === 200 || res?.status === 201) {
      dispatch(addPrivacyPolicy(res?.data?.data));
      // setHtml(res?.data?.data?.[0]?.data);
    }

    dispatch(addisLoading(false));
  };
  useEffect(() => {
    fetchChats();
  }, []);

  console.log("New- prvacy- custoemer ", newPrivacy);

  // const handleCall2 = async () => {
  //   setisLoading(true);
  //   try {
  //     // Use a for loop to process items sequentially
  //     for (const item of customerTerms || []) {
  //       // Ensure each API call is awaited
  //       const res = await addSettingsContent(item);
  //       // Handle the response as needed (e.g., logging or further processing)
  //       console.log(res);
  //     }
  //     // Show success toast after all promises are resolved
  //     toast("Settings Added Successfully", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //     });
  //   } catch (error) {
  //     // Handle errors (e.g., show an error toast)
  //     console.error("Error adding settings:", error);
  //     toast("Error adding settings", { type: "error" });
  //   } finally {
  //     // Set loading state to false, whether the operation succeeds or fails
  //     setisLoading(false);
  //   }
  // };

  const initialValue: any = {
    title: "",
    body: "",
    tag: "Customer Terms",
  };
  const [CTerms, setCTerms] = useState(initialValue);

  const privacyPolicy: any = useAppSelector(
    (store: RootState) => store.user.privacyPolicy
  );

  console.log("------vOVR", privacyPolicy);

  const handleAddSettings = async (item: any) => {
    setisLoading(true);
    // dispatch(addisLoading(true));
    try {
      const res = await addSettingsContent(item);
      console.log(res);
      toast("Settings Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error("Error adding settings:", error);
      toast("Error adding settings", { type: "error" });
    } finally {
      // dispatch(addisLoading(false));
      fetchChats();
      setOpen(false);
      setCTerms(initialValue);
      setisLoading(false);
    }
  };

  const [selectedItem, setSelectedItem] = useState<any>();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(!open);
  const [openDelete, setOpenDelete] = React.useState(false);
  const handleOpenDelete = () => setOpenDelete(!open);

  const [isLoading, setisLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCTerms({
      ...CTerms,
      [name]: value,
    });
  };

  const handleEditClick = (item: any) => {
    // setSelectedItem(item);
    setCTerms({
      title: item.title,
      body: item.body,
      tag: "Customer Terms",
      id: item.id,
    });
    setOpen(true);
  };

  const customerTerms = [
    {
      title: "Terms of Service for Pureworker App",
      body: 'These Terms of Service ("Terms") constitute a legally binding agreement between Pureworker ("Pureworker", "we", "us", or "our"), and you, the user of the Pureworker app ("you", "your", or "user"). By accessing or using the Pureworker app, you agree to be bound by these Terms, our Privacy Policy, and any additional terms and conditions that are referenced herein or that otherwise apply to your use of the Pureworker app.',
      tag: "Customer Terms",
    },
    {
      title: "Overview of the Pureworker App",
      body: "The Pureworker app is a platform that connects Customers, Freelancers, and Businesses in Nigeria seeking to buy and sell services. Customers can search for services on the app, and Freelancers and Businesses located nearest to the customer's location will be chosen to provide quotes. The customer can then select the Freelancer or Business they prefer, and schedule the job with them. After the service, the customer can review the Freelancer or Business, and the Freelancer or Business can review the customer.",
      tag: "Customer Terms",
    },
    {
      title: "Registration and Use of the Pureworker App",
      body: "To use the Pureworker app, you must register and create an account. When registering, you agree to provide accurate, current, and complete information about yourself, and to update such information as necessary to maintain its accuracy. You also agree to keep your login credentials confidential, and to immediately notify Pureworker if you become aware of any unauthorized use of your account. You agree to use the Pureworker app in accordance with these Terms, and to comply with all applicable laws and regulations. You agree not to use the Pureworker app for any illegal or fraudulent activities.",
      tag: "Customer Terms",
    },
    {
      title: "Cancellation of Orders",
      body: "Orders can only be canceled 5 hours before the scheduled delivery time.",
      tag: "Customer Terms",
    },
    {
      title: "Order Status",
      body: "Orders on the Pureworker app can have the following statuses:\n- Order Placed: The customer places an order for a service.\n- Order Accepted: The Freelancer or Business accepts the order.\n- Order Declined: The Freelancer or Business declines the order.\n- Order In Progress: The Freelancer or Business works on the job, and the customer can track the progress in real-time. They can also communicate with the Freelancer or Business through the app's messaging system.\n- Order Delivered: Once the Freelancer or Business completes the job, they indicate through the app.\n- Order Dispute: If the customer is not satisfied with the job, they can dispute the order, and the app's support team will investigate the issue and provide a resolution.\n- Order Completed: The customer approves the job, and the order is marked as completed. The Freelancer or Business receives payment for their work.\n- Order Canceled: The customer or Freelancer or Business cancels the order before the start of the job.",
      tag: "Customer Terms",
    },
    {
      title: "Fees",
      body: "Pureworker charges a service fee of 10% to 20% for each service rendered by Freelancers and Businesses on the platform.",
      tag: "Customer Terms",
    },
    {
      title: "Location Tracking",
      body: "The Pureworker app may allow customers to view the location of Freelancers or Businesses. This feature is only available for on-site services, and customers will only be able to view the location 1 hour before the scheduled delivery time. For off-site services, the customer will not be able to view the location at all.",
      tag: "Customer Terms",
    },
    {
      title: "Dispute Resolution",
      body: "If a dispute arises between a customer and a Freelancer or Business, the parties should first try to resolve the dispute themselves. If the dispute cannot be resolved, the customer can file a dispute with Pureworker. Pureworker will investigate the dispute and provide a resolution.",
      tag: "Customer Terms",
    },
    {
      title: "Termination",
      body: "We may terminate your access to and use of the Pureworker app at any time without notice or liability, including if we determine in our sole discretion that:\n- You have violated any provision of these Terms of Service\n- Your use of the Pureworker app violates any applicable law or regulation\n- Your conduct is harmful to our business interests, reputation or goodwill, or to any other users of the Pureworker app\nUpon termination, you must immediately stop using the Pureworker app and delete any copies of the app in your possession or control.\nNotwithstanding the foregoing, Pureworker may take such action as Pureworker deems appropriate to deal with any breach of the Terms in any way, including suspending your access to the app, prohibiting you from accessing the app, blocking computers using your IP address from accessing the app, contacting your internet service provider requesting that your access to the website be blocked and/or bringing court proceedings against You.",
      tag: "Customer Terms",
    },
    {
      title: "Intellectual Property",
      body: "All content and materials available on the Pureworker app, including but not limited to trademarks, logos, graphics, images, text, software, and the arrangement of such content and materials (collectively, the 'Content'), are owned or licensed by Pureworker and are protected by Nigerian and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. You may not use, reproduce, distribute, display, modify, or create derivative works of any of the Content without our prior written permission. Any unauthorized use of the Content may violate copyright, trademark, and other applicable laws and could result in criminal or civil penalties.",
      tag: "Customer Terms",
    },
    {
      title: "Disclaimer of Warranties",
      body: "The Pureworker app and all content, materials, and services available through the app are provided on an 'as is' and 'as available' basis, without warranties of any kind, either express or implied. Pureworker disclaims all warranties, express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, non-infringement, and title. Pureworker does not warrant that the app or any of its content, materials, or services will be uninterrupted, error-free, or free from viruses or other harmful components. You acknowledge that your use of the app and its content, materials, and services is at your sole risk.",
      tag: "Customer Terms",
    },
    {
      title: "Limitation of Liability",
      body: "In no event shall Pureworker or its affiliates, directors, officers, employees, agents, or licensors be liable for any direct, indirect, incidental, special, consequential, punitive, or exemplary damages arising out of or in connection with your use of the app or its content, materials, or services, even if Pureworker has been advised of the possibility of such damages. If any jurisdiction does not allow the exclusion or limitation of liability for consequential or incidental damages, the liability of Pureworker and its affiliates, directors, officers, employees, agents, or licensors shall be limited to the greatest extent permitted by law.",
      tag: "Customer Terms",
    },
    {
      title: "Indemnification",
      body: "You agree to indemnify, defend, and hold harmless Pureworker and its affiliates, directors, officers, employees, agents, and licensors from and against all claims, losses, expenses, damages, and costs, including reasonable attorneys' fees, arising out of or in connection with your use of the app, your violation of these Terms of Service, or your violation of any applicable law or regulation.",
      tag: "Customer Terms",
    },
    {
      title: "Governing Law and Jurisdiction",
      body: "These Terms of Service shall be governed by and construed in accordance with the laws of Nigeria without regard to its conflict of law provisions. Any dispute arising out of or in connection with these Terms of Service shall be resolved in the courts of Nigeria.",
      tag: "Customer Terms",
    },
    {
      title: "Changes to Terms of Service",
      body: "We reserve the right, at our sole discretion, to modify or replace these Terms of Service at any time. If we make material changes to these Terms of Service, we will notify you by posting the new terms on the Pureworker app or sending you an email or other communication. Your continued use of the app following the posting of any changes to these Terms of Service constitutes your acceptance of those changes.",
      tag: "Customer Terms",
    },
    {
      title: "Prohibited Activities",
      body: "You shall not solicit, encourage or indulge in any of the following activities:\n- Demanding and/or receiving gifts from customers;\n- Inappropriate sexual relations with customers;\n- Engaging in the unauthorized sale of brand name or designer products or services;\n- Selling products that infringe on the intellectual property rights of Pureworker or others, including counterfeit goods or any product or service that infringes on the copyright, trademark or trade secrets of Pureworker or any third party;\n- Engaging in provision of services that represent a violation of any law, statute or regulation.\n- Any unlawful activities/items or encouragement of the same.",
      tag: "Customer Terms",
    },
    {
      title: "Entire Agreement",
      body: "These Terms of Service constitute the entire agreement between you and Pureworker with respect to the use of the Pureworker app and its content, materials, and services and supersede all prior or contemporaneous communications and proposals.",
      tag: "Customer Terms",
    },
  ];

  const handleDelete = async (id: any) => {
    setisLoading(true);
    const res: any = await deleteContent(id);
    if (res?.status === 200 || res?.status === 201) {
      toast("Content Deleted Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // setOpen(false);
      setOpenDelete(false);
      fetchChats();
    }
    // dispatch(addisLoading(false));
    setOpenDelete(false);
    setisLoading(false);
  };

  console.log(CTerms);

  return (
    <>
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4">
          Edit Customer Privacy Policy
        </p>
      </div>
      <section className="px-2 lg:px-6 mt-6 w-full lg:w-4/5">
        <main className="bg-[#8E8E93] border border-[#88087B] rounded-sm ">
          <div className="flex flex-col">
            <p className="pb-2 font-roboto text-base font-normal leading-5">
              Content:
            </p>
            <div className=" bg-[#fff] rounded-3xl p-4 h-screen overflow-y-auto">
              <div className="text-right">
                <button
                  onClick={() => {
                    setOpen(true);
                    // handleCall2()
                  }}
                  className="bg-green-600 py-2 px-4 rounded-md text-white my-3"
                >
                  Add Privacy
                </button>
              </div>
              <div className="space-y-4">
                {newPrivacy?.map((item: any, index: any) => {
                  return (
                    <div
                      className="space-y-4 p-4 border rounded-md"
                      key={index}
                    >
                      <div className="flex justify-end gap-3 my-3">
                        <div
                          className="ml-3"
                          onClick={() => {
                            // setSelectedItem(item);
                            handleEditClick(item);
                          }}
                        >
                          <MdEdit size={24} />
                        </div>
                        <div
                          className="ml-3"
                          onClick={() => {
                            setSelectedItem(item);
                            setOpenDelete(true);
                            // handleDelete(item?.selected)
                          }}
                        >
                          <MdDeleteOutline
                            size={25}
                            className=" cursor-pointer text-[#fff] bg-[#D11C1C] rounded-md p-0.5"
                          />
                        </div>
                      </div>
                      <p className="font-bold">{item?.title}</p>

                      <p dangerouslySetInnerHTML={{ __html: item?.body }} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </main>
      </section>

      <Dialog open={open} handler={handleOpen}>
        <DialogBody>
          <section className="flex flex-col lg:flex-row w-full  gap-16 px-3 lg:px-6 ">
            <div className="flex flex-col gap-7 w-full  font-roboto text-sm font-normal leading-normal">
              <div className="mb-0">
                <label
                  htmlFor="qst"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Title
                </label>
                <input
                  type="text"
                  id="qst"
                  name="title"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Edit Title"
                  required
                  value={`${CTerms?.title}`}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-0">
                <label
                  htmlFor="qst"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Body
                </label>
                <TextEditor
                  value={CTerms?.body ?? ""}
                  setValue={(htmlText) =>
                    setCTerms({
                      ...CTerms,
                      body: htmlText,
                    })
                  }
                />
              </div>
              <div className="px-12 w-full flex justify-center items-center lg:block">
                {isLoading ? (
                  <>
                    <Dots size={40} color="var(--admin-accent)" />
                  </>
                ) : (
                  <button
                    onClick={(e) => {
                      handleAddSettings(CTerms);
                    }}
                    className="bg-[#88087B] text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal sm:w-3/4 lg:w-[40%] lg:mx-auto py-2.5 rounded-md mt-4 "
                  >
                    Save Changes
                  </button>
                )}
              </div>
            </div>
          </section>
        </DialogBody>
      </Dialog>
      <Dialog open={openDelete} handler={handleOpenDelete}>
        <DialogHeader>Delete Content</DialogHeader>
        <DialogBody>
          <div className="relative p-4 w-full  max-h-full flex  flex-col">
            <div className="p-4 md:p-5 text-center mx-auto ">
              <svg
                className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to delete {selectedItem?.title} ?
              </h3>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
                onClick={() => {
                  handleDelete(selectedItem?.id || selectedItem?._id);
                }}
              >
                Yes, I'm sure
              </button>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={() => {
                  setOpenDelete(false);
                }}
              >
                No, cancel
              </button>
            </div>
            {isLoading && (
              <>
                <Dots size={40} color="var(--admin-accent)" />
              </>
            )}
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default CustomerTerms;
